// components/Portfolio.tsx
import Footer from 'components/Footer';
import PortfolioGrid from 'components/PortfolioGrid';
import PortfolioHero from 'components/Portfoliohero';
import React from 'react';

const Portfolio: React.FC = () => {
  return (
    <div>
      <PortfolioHero />
      <PortfolioGrid />
      <Footer />
    </div>
  );
};

export default Portfolio;
